<template>
  <div class="product-options">
    <div class="options-top-bar " ref="optionsTopBar" >
      <h6 class="pull-left">{{$t('catalogProd.single')}} {{$t('catalogProdOpt.plural')}}</h6>
      <div class="text-right">
        <p class="">
          <button type="submit" @click.prevent="validate" :title="$t('general.update')" class="btn btn-icon btn-success mar-rt-40"><i class="ti-save"></i></button>
        </p>
      </div>
    </div>

    <div class="options-content"
            :style="{height: windowHeight - pageTopHeight - navbarHeaderHeight - 1 + 'px'}"
            ref="optionsContainer">
      <div :class="(loading ? 'show-loader' : 'hide-loader')">
        <div class="el-loading-spinner">
          <svg viewBox="25 25 50 50" class="circular">
            <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
          </svg><!---->
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <form class="clearfix ">
            <p class="text-danger" v-show="errors.has('error')">
              {{ getError('error') }}
            </p>
            <table class="table align-top">
              <thead>
                  <tr>
                    <th width="3%"></th>
                    <th width="15%">{{$t('catalogProdOpt.name')}}</th>
                    <th width="17%">{{$t('catalogProdOpt.type')}}</th>
                    <th width="10%" v-if="showLocations">{{$t('catalogProd.availableIn')}}</th>
                    <th width="3%">{{$t('catalogProdOpt.menuQr')}}</th>
                    <th width="3%">{{$t('settingLocationGroups.active')}}</th>
                    <th width="55%">{{$t('catalogProdOpt.values')}} - {{$t('catalogProd.price')}} - {{$t('catalogProdOpt.posid')}} - {{$t('catalogCateg.vat')}} <small>({{$t('catalogCateg.included')}})</small> - {{$t('catalogProd.status')}}</th>
                    <th width="5%"></th>
                  </tr>
              </thead>
              <tbody>
                <tr v-for="(option, optionKey) in model.products_options">
                  <td><button class="btn btn-icon btn-danger" @click.prevent="deleteOption(option.id, optionKey)" :title="$t('general.remove') + ' ' + $t('catalogProdOpt.single')"><i class="ti-close"></i></button></td>
                  <td>
                    <input type="text"
                            :placeholder="$t('catalogProdOpt.name')"
                            class="form-control"
                            v-model="option.name"
                            v-validate="modelValidate.required">
                  </td>
                  <td>
                    <div class="row">
                      <select v-model="option.type" class="form-control">
                        <option v-for="(opt, key) in optionTypes" :value="key">{{opt}}</option>
                      </select>
                    </div>

                    <div class="row" style="margin-top: 15px;" v-if="extraFields">
                      <div class="col-md-6" style="padding-left: 0;">
                        <label for="min_no">{{ $t('catalogProd.minNoSelected') }}</label>
                        <input type="number"
                              name="min_no"
                              v-model="option.min_no"
                              :placeholder="$t('catalogProd.minNoSelected')"
                              class="form-control">
                      </div>
                      <div class="col-md-6" style="padding-right: 0;">
                        <label for="min_no">{{ $t('catalogProd.maxNoSelected') }}</label>
                        <input type="number"
                                name="max_no"
                                v-model="option.max_no"
                                :placeholder="$t('catalogProd.maxNoSelected')"
                                class="form-control">
                      </div>
                    </div>
                  </td>
                  <td v-if="showLocations">
                    <template >
                      <v-select v-model="option.location_ids"
                                  multiple
                                  :options="locations"
                                   value="id"
                                  label="name"
                                  :ref="'option' + option.id"
                                  :placeholder="$t('general.all')"
                                  class=""
                                  :key="'option' + option.id">
                      </v-select>
                    </template>
                  </td>
                  <td>
                    <template>
                      <div class="form-group pad-lf-8 pad-to-8">
                        <div class="col-md-12">
                          <p-checkbox
                            v-model="option.display_in_dynamic_menu"
                            class="text-purple"
                            :value="option.display_in_dynamic_menu"
                            :label="$t('displayInMenu')">
                          </p-checkbox>
                        </div>
                      </div>
                    </template>
                  </td>
                  <td>
                    <template>
                      <div class="form-group pad-lf-8 pad-to-8">
                        <div class="col-md-12">
                          <p-checkbox
                            v-model="option.active"
                            class="text-purple"
                            :value="option.active"
                            :label="$t('settingLocationGroups.active')">
                          </p-checkbox>
                        </div>
                      </div>
                    </template>
                  </td>
                  <td>
                    <template v-for="(val, valueKey) in option.values">
                      <tr>
                        <input type="text"
                                placeholder=""
                                class="form-control sml mar-bt-5"
                                v-model="val.name"
                                v-validate="modelValidate.required">
                        <input type="text"
                                :placeholder="$t('catalogProdOpt.posid')"
                                class="form-control sml mar-bt-5"
                                style="width: 20%;"
                                v-model="val.pos_id">
                        <select
                          v-if="taxesVersion === 2"
                          v-model="model.products_options[optionKey].values[valueKey].vat_rate_id"
                          class="form-control sml mar-bt-5"
                          style="width: 20%;">
                          <option :value="null">{{ $t('vat.selectVat') }}</option>
                          <option
                            v-for="vat in vatOptions"
                            :key="vat.id"
                            :value="vat.id"
                            :disabled="isVatOptionDisabled(vat, model.products_options[optionKey].values[valueKey].vat_rate_id)"
                          >{{ vat.rate }}%{{ !vat.is_active ? ' (inactiv)' : '' }}
                          </option>
                        </select>
                        <select
                          v-else
                          v-model="model.products_options[optionKey].values[valueKey].vat_id"
                          class="form-control sml mar-bt-5"
                          style="width: 20%;">
                          <option value="null">{{ $t('vat.selectVat') }}</option>
                          <option
                            v-for="vat in vatOptions"
                            :value="vat.id"
                          >{{ vat.amount }}
                          </option>
                        </select>
                        <p-checkbox
                          v-model="model.products_options[optionKey].values[valueKey].active"
                          class="text-purple"
                          :disabled="model.products_options[optionKey].values[valueKey].active && isLastActiveOptionValue(model.products_options[optionKey].values)"
                          style="display: inline-block; margin-left: 30px;"
                          :value="model.products_options[optionKey].values[valueKey].active"
                          :label="$t('settingLocationGroups.active')">
                        </p-checkbox>
                        <button class="btn btn-simple btn-icon" @click.prevent="deleteValue(optionKey, parseInt(valueKey))"><i :title="$t('general.delete')" class="ti-close text-orange"></i></button>
                        <button v-if="!model.products_options[optionKey].values[valueKey].show" class="btn btn-simple btn-icon" @click.prevent="expandRow(optionKey, parseInt(valueKey), 1)"><i :title="$t('general.delete')" class="ti-arrow-down text-grey"></i></button>
                        <button v-if="model.products_options[optionKey].values[valueKey].show" class="btn btn-simple btn-icon" @click.prevent="expandRow(optionKey, parseInt(valueKey), 0)"><i :title="$t('general.delete')" class="ti-arrow-up text-grey"></i></button>
                        <br/>
                      </tr>
                      <tr v-if="model.products_options[optionKey].values[valueKey].show">
                        <input type="text"
                                :placeholder="$t('catalogProdOpt.sgrName')"
                                class="form-control sml mar-bt-5"
                                v-model="val.name_sgr">
                        <input type="text"
                                :placeholder="$t('catalogProdOpt.sgrPos')"
                                class="form-control sml mar-bt-5"
                                style="width: 20%;"
                                v-model="val.pos_id_sgr">
                        <select
                          v-if="taxesVersion === 2"
                          v-model="model.products_options[optionKey].values[valueKey].vat_rate_id_sgr"
                          class="form-control sml mar-bt-5"
                          style="width: 20%;">
                          <option :value="null">{{ $t('vat.selectVat') }}</option>
                          <option
                            v-for="vat in vatOptions"
                            :key="vat.id"
                            :value="vat.id"
                            :disabled="isVatOptionDisabled(vat, model.products_options[optionKey].values[valueKey].vat_rate_id_sgr)"
                          >{{ vat.rate }}%{{ !vat.is_active ? ' (inactiv)' : '' }}
                          </option>
                        </select>
                        <select
                          v-else
                          v-model="model.products_options[optionKey].values[valueKey].vat_id_sgr"
                          class="form-control sml mar-bt-5"
                          style="width: 20%;">
                          <option value="null">{{ $t('vat.selectVat') }}</option>
                          <option
                            v-for="vat in vatOptions"
                            :value="vat.id"
                          >{{ vat.amount }}
                          </option>
                        </select>
                        <input type="text"
                                :placeholder="$t('catalogProdOpt.sgrVal')"
                                class="form-control sml mar-bt-5"
                                style="width: 20%;"
                                v-model="val.price_sgr">
                        <br/>
                        <br/>
                      </tr>
                    </template>
                    <button class="btn btn-simple btn-icon " @click.prevent="addNewValue(option.id)"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('catalogProdOpt.value')}}</button>
                  </td>
                  <td>
                  <button class="btn btn-icon btn-info" @click.prevent="duplicateOption(option.id)" :title="$t('general.duplicate') + ' ' + $t('catalogProdOpt.single')"><i class="ti-files"></i></button></td>
                </tr>
                <tr >
                  <td colspan="5"><button class="btn btn-icon btn-info" @click.prevent="addNewOption()"><i class="ti-plus"></i> {{$t('general.add')}} {{$t('catalogProdOpt.single')}}</button></td>
                </tr>
              </tbody>
            </table>

           <!-- <div class=" text-center pad-to-15 pad-bt-15">
              <button type="submit" class="btn btn-fill btn-success btn-wd" @click.prevent="validate">{{$t('general.update')}}</button>
            </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Input} from 'element-ui'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  // import {mapFields} from 'vee-validate'
  Vue.use(Input)

  export default {
    components: {
      [Input.name]: Input
    },
    props: {
      // modeldata: {}
    },
    watch: {
      // modeldata (value) {
      //   this.model = value
      // }
    },
    data () {
      return {
        model: [],
        modelValidate: {
          name: {required: true},
          required: {required: true}
        },
        optionTypes: {
          'checkbox': this.$t('checkbox'),
          'radio': this.$t('radio'),
          'upload': this.$t('productOptions.upload')
        },
        windowHeight: 0,
        navbarHeaderHeight: 0,
        pageTopHeight: 76,
        loading: true,
        showLocations: false,
        locations: [],
        vatOptions: [],
        taxesVersion: Number((this.$session.get('selectedCompanyData') || {}).taxes_version || 1),
        deleteOptionValues: [],
        deleteOptions: [],
        extraFields: false
      }
    },
    created () {
      this.$nextTick(function () {
        this.loading = true
      })
      var data = {
        token: this.$session.get('token'),
        detailed_options: 1
      }
      var self = this

      let companyData = this.$session.get('selectedCompanyData')

      this.extraFields = companyData.glovo_active

      this.locations = companyData.locations_details
      if (this.locations.length > 1) {
        this.showLocations = true
      }

      this.apiRequest('/listdefaults', 'GET', data, function (response) {
        if (response.status === true) {
          self.defaultData = response.data[0]
        }
      })

      this.getData()
    },
    mounted () {
      this.getVatOptions()
      this.$nextTick(() => {
        this.doHeightCalculation()

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      getData () {
        var data = {
          token: this.$session.get('token'),
          detailed_options: 1
        }
        var companyID = this.$session.get('selectedCompany')

        this.apiRequest('/settings/general/' + companyID, 'GET', data, (response2) => {
          if (response2.status === true) {
            this.model = response2.data[0]
            this.$nextTick(function () {
              this.loading = false
            })
          }
        })
      },
      isLastActiveOptionValue (optionValues) {
        let counter = optionValues.filter(item => {
          return item.active === true
        })

        return counter.length === 1
      },
      updateVatPrinterId (obj) {
        const selectElement = obj.target
        const selectedOptionId = selectElement.options[selectElement.selectedIndex].id
        this.model.vat_id = selectedOptionId
      },
      getVatOptions (locaitonIds) {
        var data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: locaitonIds
        }
        const endpoint = this.taxesVersion === 2 ? '/taxes-v2/vat-rates' : '/location/vat'
        this.apiRequest(endpoint, 'GET', data, (response) => {
          if (response.status === true) {
            this.vatOptions = response.data
          }
        })
      },
      isVatOptionDisabled (vat, selectedId) {
        return !!(this.taxesVersion === 2 && vat && !vat.is_active && String(vat.id) !== String(selectedId))
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate (pageId) {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
      },
      addNewValue (optId) {
        let newRow = {
          'id': null,
          'name': '',
          'vat_rate_id': null,
          'vat_rate_id_sgr': null,
          'active': true
        }

        let zElement = Object.values(this.model.products_options).filter(function (element) {
          return element.id === optId
        })

        if (Array.from(zElement[0].values).length === 0) {
          zElement[0].values = Array.from(Object.values(zElement[0].values))
        }

        zElement[0].values.push(newRow)
      },
      addNewOption () {
        let newRow = {
          'id': null,
          'name': '',
          'active': true,
          'type': '',
          'location_ids': [],
          'values': []
        }

        let newOption = {
          'id': null,
          'name': '',
          'active': true
        }

        newRow.values.push(newOption)

        if (!this.model.products_options) {
          this.model.products_options = []
        }

        this.model.products_options.push(newRow)
      },
      duplicateOption (optId) {
        // let counter = 1

        var optIdx = this.getObjectByElemKeyValue('id', optId, this.model.products_options)
        // counter += this.model.products_options[optIdx].values.length

        let newOpt = {
          'name': this.model.products_options[optIdx].name,
          'active': this.model.products_options[optIdx].active,
          'type': this.model.products_options[optIdx].type,
          'location_ids': this.model.products_options[optIdx].location_ids,
          'display_in_dynamic_menu': this.model.products_options[optIdx].display_in_dynamic_menu,
          'values': this.copyCompanyOptionValueWithoutIds(this.model.products_options[optIdx].values)
        }
        // if (this.model.products_options[optIdx].location_ids !== undefined) {
        //   newOpt.location_ids = [...this.model.products_options[optIdx].location_ids]
        // }
        this.model.products_options.push(newOpt)
        this.locations = this.locations
        this.$nextTick(function () {
        })
      },
      deleteValue (optId, valId) {
        this.deleteOptionValues.push(this.model.products_options[optId].values[valId].id)
        this.model.products_options[optId].values.splice(valId, 1)
      },
      expandRow (optId, valId, val) {
        this.$nextTick(() => { Vue.set(this.model.products_options[optId].values[valId], 'show', val) })
      },
      deleteOption (optId, optionKey = null) {
        if (!optId) {
          this.model.products_options.splice(optionKey, 1)
          return
        }
        var self = this
        swal({
          text: self.$t('catalogProdOpt.areyouSure'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        }).then((result) => {
          if (result) {
            var data = {
              token: this.$session.get('token'),
              company_id: this.$session.get('selectedCompany'),
              product_option_id: optId
            }
            this.apiRequest('/settings/usage', 'POST', data, function (response) {
              if (response.status) {
                var optIdx = self.getObjectByElemKeyValue('id', optId, self.model.products_options)
                self.deleteOptions.push(optId)
                self.model.products_options.splice(optIdx, 1)
              } else {
                // console.warn(response)
                var msg = response.errors['product_option_id'] ? self.$t('catalogProd.optionInUse') : self.$t('validations.wentWrong')
                swal(
                  '',
                  msg,
                  'error'
                )
              }
            })
          }
        }).catch(() => {
         //
        })
      },
      saveDetails () {
        this.$nextTick(function () {
          this.loading = true
        })
        var companyID = this.$session.get('selectedCompany')

        let options = this.copyObject(this.model.products_options)

        for (let idxO in options) {
          let locIds = []
          if (options[idxO].location_ids) {
            for (let idxL in options[idxO].location_ids) {
              locIds.push(options[idxO].location_ids[idxL]['token'])
            }
          }
          options[idxO].location_ids = locIds

          for (let idxV in options[idxO].values) {
            if (this.taxesVersion === 2) {
              delete options[idxO].values[idxV].vat_id
              delete options[idxO].values[idxV].vat_id_sgr
            } else {
              delete options[idxO].values[idxV].vat_rate_id
              delete options[idxO].values[idxV].vat_rate_id_sgr
            }
          }
        }
        // data['location_ids'] = JSON.stringify(locIds)
        var data = {
          'token': this.$session.get('token'),
          'products_options': JSON.stringify(options),
          'validate_products_options': 1,
          'delete_options': this.deleteOptions,
          'delete_option_values': this.deleteOptionValues
        }

        this.apiRequest('/settings/general/' + companyID, 'PUT', data, (response) => {
          if (response.status === true) {
            this.getData()
            this.errors.clear()
            this.$nextTick(function () { this.loading = false })
            swal({'text': this.$t('catalogProdOpt.optionSaved'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            this.$nextTick(function () { this.loading = false })

            if (response.errors && response.errors.option_location) {
              swal({'text': this.$t('catalogProdOpt.optLocationError', response.errors.option_location), 'type': 'error', 'showConfirmButton': true}).catch(() => {})
            } else {
              swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            }
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Tabs/ProductOptions.vue